module.exports = __webpack_public_path__ + "img/lille.8a96faac.png";